export default __webpack_public_path__ + "1090f4bd2725b76accfcd225ea2dec06.png";